import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
import styled from 'styled-components';
import { getPointingTransform } from '../../icon/utils';
var Chevron = styled(Icon).withConfig({
  displayName: "ChevronIcon__Chevron",
  componentId: "jfyegr-0"
})(["", ""], function (_ref) {
  var pointing = _ref.pointing;
  return getPointingTransform(pointing);
});
var basicPath = 'M23.99 35.11C23.788 35.1117 23.5879 35.0716 23.4021 34.9925C23.2162 34.9133 23.0488 34.7968 22.91 34.6501L4.57003 15.45C4.42802 15.3087 4.31576 15.1405 4.23983 14.9551C4.1639 14.7698 4.1258 14.5712 4.12789 14.3709C4.12998 14.1706 4.17225 13.9727 4.25203 13.789C4.33182 13.6053 4.44756 13.4394 4.59249 13.3012C4.73742 13.1629 4.90851 13.0551 5.09579 12.984C5.28306 12.913 5.48266 12.8803 5.68282 12.8876C5.88298 12.895 6.07975 12.9423 6.26131 13.0269C6.44287 13.1115 6.60555 13.2315 6.73995 13.38L23.99 31.44L41.26 13.34C41.3944 13.1915 41.5572 13.0714 41.7387 12.9869C41.9203 12.9023 42.1169 12.8549 42.3171 12.8476C42.5173 12.8402 42.7169 12.873 42.9041 12.944C43.0914 13.015 43.2626 13.1229 43.4076 13.2611C43.5525 13.3994 43.6682 13.5653 43.748 13.7491C43.8278 13.9328 43.8701 14.1306 43.8722 14.3308C43.8742 14.5311 43.8361 14.7298 43.7602 14.9152C43.6843 15.1005 43.572 15.2688 43.43 15.4101L25.08 34.6501C24.939 34.7966 24.7696 34.9129 24.5822 34.992C24.3949 35.0711 24.1933 35.1112 23.99 35.11Z';
var filledPath = 'M23.99 35.11C23.788 35.1116 23.5879 35.0716 23.4021 34.9925C23.2162 34.9133 23.0488 34.7968 22.91 34.6501L4.57003 15.45C4.42802 15.3087 4.31576 15.1405 4.23983 14.9551C4.1639 14.7698 4.1258 14.5712 4.12789 14.3709C4.12998 14.1706 4.17225 13.9727 4.25203 13.789C4.33182 13.6053 4.44756 13.4394 4.59249 13.3012C4.73742 13.1629 4.90851 13.0551 5.09578 12.984C5.28306 12.913 5.68282 12.8876 5.68282 12.8876L42.3171 12.8476C42.3171 12.8476 42.7169 12.873 42.9041 12.944C43.0914 13.015 43.2626 13.1229 43.4076 13.2611C43.5525 13.3994 43.6682 13.5653 43.748 13.7491C43.8278 13.9328 43.8701 14.1306 43.8722 14.3308C43.8742 14.5311 43.8361 14.7298 43.7602 14.9152C43.6843 15.1005 43.572 15.2688 43.43 15.4101L25.08 34.6501C24.939 34.7966 24.7696 34.9129 24.5822 34.992C24.3949 35.0711 24.1933 35.1112 23.99 35.11Z';
var ChevronIcon = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var iconFill = _ref2.iconFill,
      props = _objectWithoutProperties(_ref2, ["iconFill"]);

  var path = basicPath;

  if (iconFill && iconFill === 'fill') {
    path = filledPath;
  }

  return /*#__PURE__*/React.createElement(Chevron, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: path
  }));
});
ChevronIcon.displayName = 'ChevronIcon';
ChevronIcon.defaultProps = {
  'aria-label': 'Chevron',
  pointing: 'down'
};
export default ChevronIcon;